//@flow

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import {
  handleFreeze,
  updateOverviewEdits,
} from '../../redux/actions/overviewEditorActions';
import { closeOverviewModal } from '../../redux/actions/trekOverviewActions';
import { getToastMsg } from '../../components/ErrorMessage';

type Props = {
  closeOverviewModal: () => void,
  updateOverviewEdits: () => void,
  isFrozen: boolean,
  trekId: string,
  handleFreeze: () => void,
};

type State = { isSaving: boolean };

class LockTrek extends Component<Props, State> {
  state = { isSaving: false };

  toggleInclusion = async () => {
    const {
      isFrozen,
      trekId,
      handleFreeze,
      updateOverviewEdits,
      closeOverviewModal,
    } = this.props;
    this.setState({ isSaving: true });

    const data = { is_frozen: !isFrozen };

    try {
      await handleFreeze(trekId, isFrozen);
      updateOverviewEdits(data);
      this.setState({ isSaving: false });
      getToastMsg({ status: 'success', type: 'freezeTrek', data });
      closeOverviewModal();
    } catch (err) {
      this.setState({ isSaving: false });
      getToastMsg({ status: 'error', type: 'freezeTrek', data });
    }
  };

  render() {
    const { closeOverviewModal, isFrozen } = this.props;
    const { isSaving } = this.state;

    const title = isFrozen ? 'UNFREEZE TREK' : 'FREEZE TREK';

    const message = isFrozen
      ? 'Unfreeze this trek to let people join in.'
      : 'Once you lock the trek, no one can join it.';

    return (
      <Fragment>
        <div id="basic-info-editor">
          <div className="d-mobile">
            <div className="d-flex justify-content-between mb-2 border-bottom">
              <h2>{title}</h2>
              <a onClick={closeOverviewModal} style={{ fontSize: '14px' }}>
                <i className="icon icon-hg-cross" aria-hidden="true" />
              </a>
            </div>
          </div>
          <div className="lock-trek">
            <h6 className="mb-2">
              Do you want to {isFrozen ? 'Unfreeze' : 'Freeze'} you Trek?
            </h6>
            <p className="mb-3">{message}</p>
            <Button
              color="yellow"
              onClick={this.toggleInclusion}
              className={isSaving ? 'btn-loading' : ''}
            >
              {isFrozen ? 'Unfreeze Trek' : 'Freeze Trek'}
            </Button>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ selectedTrek }) => ({
  trekId: selectedTrek.trek.id,
  isFrozen: selectedTrek.trek.is_frozen,
});

export default connect(
  mapStateToProps,
  {
    handleFreeze,
    closeOverviewModal,
    updateOverviewEdits,
  }
)(LockTrek);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/LockTrek.jsx